import { render, staticRenderFns } from "./journalProperty.vue?vue&type=template&id=717a0546&scoped=true&"
import script from "./journalProperty.vue?vue&type=script&lang=js&"
export * from "./journalProperty.vue?vue&type=script&lang=js&"
import style0 from "./journalProperty.vue?vue&type=style&index=0&id=717a0546&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a0546",
  null
  
)

export default component.exports